const OrganizationTypeEnum = Object.freeze({
  DEFAULT: 'Default',
  PARTNER_DSP: 'PartnerDsp'
})

export default OrganizationTypeEnum
